import _toConsumableArray from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import { parse } from 'vega-expression';
function getName(node) {
  var name = [];
  if (node.type === 'Identifier') {
    return [node.name];
  }
  if (node.type === 'Literal') {
    return [node.value];
  }
  if (node.type === 'MemberExpression') {
    name.push.apply(name, _toConsumableArray(getName(node.object)));
    name.push.apply(name, _toConsumableArray(getName(node.property)));
  }
  return name;
}
function startsWithDatum(node) {
  if (node.object.type === 'MemberExpression') {
    return startsWithDatum(node.object);
  }
  return node.object.name === 'datum';
}
export function getDependentFields(expression) {
  var ast = parse(expression);
  var dependents = new Set();
  ast.visit(function (node) {
    if (node.type === 'MemberExpression' && startsWithDatum(node)) {
      dependents.add(getName(node).slice(1).join('.'));
    }
  });
  return dependents;
}